import { useState } from 'react';
import { buildShareURL } from '../../utils/urlManager';
import { convertToMistyped } from '../../utils/layoutConverter';
import styles from './SharePanel.module.css';

const SharePanel = () => {
    const [open, setOpen] = useState(false);
    const [text, setText] = useState('');
    const [copied, setCopied] = useState(false);

    const preview = text.trim() ? convertToMistyped(text.trim()) : '';

    const handleCreate = async () => {
        if (!text.trim()) return;
        const url = buildShareURL(text.trim().toLowerCase());
        try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch {
            // Fallback
            prompt('Скопируйте ссылку:', url);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleCreate();
        }
    };

    if (!open) {
        return (
            <button className={styles.trigger} onClick={() => setOpen(true)}>
                Отправить другу
            </button>
        );
    }

    return (
        <div className={styles.panel}>
            <div className={styles.header}>
                <span className={styles.title}>Отправить другу</span>
                <button className={styles.close} onClick={() => setOpen(false)}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                        <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                    </svg>
                </button>
            </div>
            <input
                className={styles.input}
                value={text}
                onChange={(e) => { setText(e.target.value); setCopied(false); }}
                onKeyDown={handleKeyDown}
                placeholder="Напишите фразу на русском..."
                autoFocus
            />
            {preview && (
                <div className={styles.preview}>
                    Друг увидит: <span>{preview}</span>
                </div>
            )}
            <button
                className={styles.createButton}
                onClick={handleCreate}
                disabled={!text.trim()}
            >
                {copied ? 'Скопировано!' : 'Скопировать ссылку'}
            </button>
        </div>
    );
};

export default SharePanel;
